/* Maison Lamora — global UI: navigation, enquiry list (quote basket), file URLs, reveal. */
(function () {
  var L = window.LAMORA = window.LAMORA || {};

  /* ---------- Files helper ---------- */
  L.fileUrl = function (name, width) {
    if (!L.filesBase) return '';
    return L.filesBase + encodeURIComponent(name) + (width ? '?width=' + width : '');
  };
  L.pieceImage = function (sku, width) { return L.fileUrl(sku + '.jpg', width || 480); };
  L.pieceSprite = function (sku) { return L.fileUrl(sku + '-sprite.webp'); };

  /* ---------- Safe storage ---------- */
  function load(key, dflt) {
    try { var v = window.localStorage.getItem(key); return v ? JSON.parse(v) : dflt; } catch (e) { return dflt; }
  }
  function save(key, val) {
    try { window.localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* storage unavailable */ }
  }
  L.store = { load: load, save: save };

  /* ---------- Enquiry list ---------- */
  var KEY = 'lamora-enquiry-v1';
  var items = load(KEY, []);
  var listeners = [];
  function emit() { save(KEY, items); listeners.forEach(function (fn) { fn(items); }); render(); }
  L.enquiry = {
    list: function () { return items.slice(); },
    has: function (id) { return items.some(function (i) { return i.id === id; }); },
    add: function (item, open) {
      item.id = item.id || ('d-' + Date.now());
      items = items.filter(function (i) { return i.id !== item.id; });
      items.push(item);
      emit();
      if (open !== false) openDrawer();
    },
    remove: function (id) { items = items.filter(function (i) { return i.id !== id; }); emit(); },
    clear: function () { items = []; emit(); },
    onChange: function (fn) { listeners.push(fn); },
    asText: function () {
      return items.map(function (i, n) {
        return (n + 1) + '. [' + i.type + '] ' + i.title + (i.detail ? ' \u00b7 ' + i.detail : '') + (i.link ? ' (' + location.origin + i.link + ')' : '');
      }).join('\n');
    }
  };

  var drawer = document.querySelector('[data-enquiry-drawer]');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render() {
    document.querySelectorAll('[data-enquiry-count]').forEach(function (el) { el.textContent = items.length; el.hidden = items.length === 0; });
    if (!drawer) return;
    var list = drawer.querySelector('[data-enquiry-list]');
    drawer.querySelector('[data-enquiry-empty]').hidden = items.length > 0;
    list.innerHTML = items.map(function (i) {
      return '<li class="enquiry-item' + (i.image ? '' : ' enquiry-item--nomedia') + '">' +
        (i.image ? '<div class="enquiry-item__media"><img src="' + esc(i.image) + '" alt="" loading="lazy" onerror="this.closest(\'.enquiry-item\').classList.add(\'enquiry-item--nomedia\')"></div>' : '') +
        '<div class="enquiry-item__info"><p class="eyebrow">' + esc(i.type) + '</p>' +
        (i.link ? '<a href="' + esc(i.link) + '" class="enquiry-item__title">' + esc(i.title) + '</a>' : '<span class="enquiry-item__title">' + esc(i.title) + '</span>') +
        (i.detail ? '<p class="fine">' + esc(i.detail) + '</p>' : '') +
        '<button type="button" class="link-btn" data-enquiry-remove="' + esc(i.id) + '">Remove</button></div></li>';
    }).join('');
    document.querySelectorAll('[data-enquiry-toggle]').forEach(function (b) {
      var on = L.enquiry.has(b.dataset.enquiryToggle);
      b.classList.toggle('is-added', on);
      var lbl = b.querySelector('[data-label]');
      if (lbl) lbl.textContent = on ? 'Added to enquiry' : (b.dataset.labelOff || 'Add to enquiry');
    });
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }
  L.openEnquiry = openDrawer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-enquiry-open]')) { openDrawer(); return; }
    if (t.closest('[data-enquiry-close]')) { closeDrawer(); return; }
    var rm = t.closest('[data-enquiry-remove]');
    if (rm) { L.enquiry.remove(rm.dataset.enquiryRemove); return; }
    var tg = t.closest('[data-enquiry-toggle]');
    if (tg) {
      var id = tg.dataset.enquiryToggle;
      if (L.enquiry.has(id)) { L.enquiry.remove(id); return; }
      L.enquiry.add({ id: id, type: tg.dataset.type || 'Installation', title: tg.dataset.title, detail: tg.dataset.detail || '', image: tg.dataset.image || '', link: tg.dataset.link || '' });
      return;
    }
    var toggle = t.closest('[data-nav-toggle]');
    if (toggle) {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open);
      document.querySelector('[data-nav]').classList.toggle('is-open', open);
      document.documentElement.classList.toggle('no-scroll', open);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Header ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 30); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Horizontal rails: drag to scroll ---------- */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var prev = rail.parentNode.querySelector('[data-rail-prev]');
    var next = rail.parentNode.querySelector('[data-rail-next]');
    var step = function () { return rail.clientWidth * 0.8; };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Model viewer loader ---------- */
  L.loadModelViewer = function () {
    if (L._mv) return L._mv;
    L._mv = new Promise(function (res) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      s.onload = function () {
        customElements.whenDefined('model-viewer').then(function () {
          var MV = customElements.get('model-viewer');
          if (MV && L.assets && L.assets.meshopt) MV.meshoptDecoderLocation = L.assets.meshopt;
          res();
        });
      };
      document.head.appendChild(s);
    });
    return L._mv;
  };
  if (document.querySelector('model-viewer')) L.loadModelViewer();

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  render();
})();

/* ── Global daylight / lights-on state ─────────────────────────────
   Single source of truth: <html data-light="day|night">, mirrored to
   localStorage so the choice follows the visitor across pages. */
(function () {
  var root = document.documentElement;

  function current() {
    return root.getAttribute('data-light') === 'night' ? 'night' : 'day';
  }

  function apply(mode) {
    root.setAttribute('data-light', mode === 'night' ? 'night' : 'day');
    document.dispatchEvent(new CustomEvent('lamora:light', { detail: { mode: mode } }));
    document.querySelectorAll('[data-light-toggle]').forEach(function (btn) {
      var on = btn.getAttribute('data-light-toggle') === mode;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    // Every page opens in daylight — the choice is deliberately not remembered.
    apply('day');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-light-toggle]');
      if (!btn) return;
      e.preventDefault();
      apply(btn.getAttribute('data-light-toggle'));
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
